export const GET_RECENT_EXPERIENCES = "GET_RECENT_EXPERIENCES";
export const RESET_RECENT_EXPERIENCES = "RESET_RECENT_EXPERIENCES";
export const SET_RECENT_EXPERIENCES_REQUEST_STATUS = "SET_RECENT_EXPERIENCES_REQUEST_STATUS";
